<template>
	<div class="dashboard-wrapper">
		<Message
			v-for="message in messages"
			:text="message.text"
			:type="message.type"
			:key="message.text"
		/>
		<OwnerDashboard v-if="userIsGroupOwner" />
		<UnfinishedModules />
		<FinishedModules />
	</div>
</template>
<script>
import ModuleCard from "./ModuleCard.vue";
import FinishedModules from "./FinishedModules.vue";
import UnfinishedModules from "./UnfinishedModules.vue";
import OwnerDashboard from "./OwnerDashboard.vue";
import Message from "./../partials/Message.vue";
import LoadingSpinner from "./../partials/LoadingSpinner.vue";
export default {
	name: "Dashboard",
	props: [],
	components: {
		ModuleCard,
		Message,
		LoadingSpinner,
		FinishedModules,
		UnfinishedModules,
		OwnerDashboard
	},
	computed: {
		loaded() {
			return this.$store.state.loaded;
		},
		messages() {
			return this.$store.state.messages.dashboard;
		},
		userIsGroupOwner() {
			return this.$store.getters.userIsGroupOwner;
		}
	},
	methods: {},
	mounted() {
		this.$store.dispatch("setCSSVariables");
	}
};
</script>